import React, { useState } from 'react'
// Project File Imports

// Material UI Imports

import { useTheme } from '@mui/material/styles'
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
} from '@mui/material'
import AuthContext from '../Contexts/AuthenticationContext'
import MenuIcon from '@mui/icons-material/Menu'
import { useContext } from 'react'
import Box from '@mui/material/Box'
import useMediaQuery from '@mui/material/useMediaQuery'
import { DarkModeSharp } from '@mui/icons-material'
import Text from '../../genericComponents/Text'

const Appbar = ({
  header,
  appbarOptions,
  toggleDarkmode,
  onOpenMenu,
}) => {
  const theme = useTheme()
  const isLgOrXL = useMediaQuery(theme.breakpoints.up('md'))
  // const isXs = useMediaQuery(theme.breakpoints.down('sm'))

  let appBarMarginLeft = '0px'
  const Icon = header?.icon;

  return (
    <AppBar position='sticky' >      
      <Toolbar
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          height: 64,
          paddingLeft: !isLgOrXL ? 0 : null,
          paddingRight: !isLgOrXL ? 0 : null,
          transition: theme.transitions.create('margin-left', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
          }),
          marginLeft: appBarMarginLeft
        }}
      >
        <Box style={{ display: 'flex', alignItems: 'center' }}>
          <Box sx={{ display: { md: "none" } }}>
            <IconButton
              aria-label='Open drawer'
              onClick={onOpenMenu}
              style={{
                color:
                  theme.palette.mode === 'dark'
                    ? theme.palette.text.primary
                    : theme.palette.background.default,
                margin: 16
              }}
            >
              <MenuIcon />
            </IconButton>
          </Box>
          <Box
            sx={(theme) => ({
              color:
                theme.palette.mode === 'dark'
                  ? theme.palette.text.primary
                  : theme.palette.background.paper,
              display: 'flex'
            })}
          >
            {Icon ? <Icon fontSize='large' /> : null }
          </Box>
          <Box>
            <Text
              variant='h1'                   
              text={header ? header.text : null}              
              noWrap
              style={{
                flex: 1,                
                paddingLeft: theme.spacing(
                  theme.appBarIconPaddingUnit ? theme.appBarIconPaddingUnit : 1
                ),
                color:
                  theme.palette.mode === 'dark'
                    ? theme.palette.text.primary
                    : theme.palette.background.paper,
              }}
            />
          </Box>
        </Box>
        <Box sx={{ display: { md: "flex" }, alignItems: "center" }}>
          <Box sx={{ display: { xs: "none", md: "block" } }}>
            {appbarOptions
              ? appbarOptions.map((item, index) => (
                <div
                  style={{
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    marginRight: theme.spacing(1.5)
                  }}
                  key={index}
                >
                  {item}
                </div>
              ))
              : null}
            {/* <IconButton
              onClick={() => toggleDarkmode()}
              style={{
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                marginRight: theme.spacing(1.5)
              }}
            >
              <DarkModeSharp />
            </IconButton> */}
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  )
}

export default Appbar
